<script>
  import Layout from "../../layouts/auth";
  import appConfig from "@/app.config";

  export default {
    components: { Layout },
    page: {
      title: "Home",
      meta: [{ name: "description", content: appConfig.description }]
    },

    data() {
      return {
        mobile_number: this.$route.params.mobile,
        otp:null
      };
    },

    methods: {
      handleSubmit() {

        let mobile_number = this.mobile_number;
        let otp = this.otp;

        this.$store.dispatch('memberLogin', {mobile_number:mobile_number, otp:otp})
          .then(() => this.$router.push('/member/details'))
          .catch((error) => {
            this.$swal({
              icon: 'error',
              title: 'Oops...',
              text: error.response.data.message
            });
          });
      },

      resend() {
        this.callAPI({
          endpoint: `/member/login/resend`,
          type: 'POST',
          data: {mobile_number: this.mobile_number},
          sweetalert:true,
          failureCallBack: (error) => {
            this.$swal({
              icon: 'error',
              title: 'Oops...',
              text: error.response.data.message
            });
            this.$router.go(-1);
          }
        });
      }
    }
  }
</script>
<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h4 class="text-primary calibri">पारसधाम ऑनलाइन</h4>
                  <p>Members 2fa Authentication</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img src="@/assets/images/profile-img.png" alt class="img-fluid" />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <router-link tag="a" to="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img src="@/assets/images/logo.svg" alt height="34" />
                  </span>
                </div>
              </router-link>
            </div>

            <p class="text-primary">Please enter otp received on {{this.mobile_number}} or your email address to continue.</p>

            <b-form class="p-2" @submit.prevent="handleSubmit">

              <div class="form-group">
                <label class="required">Enter Otp</label>
                <input v-model="otp" placeholder="xxxxx" class="form-control" type="number" />
              </div>

              <p>Didn't receive? <button class="btn btn-link" @click="resend" type="button">Resend OTP</button></p>

              <div class="mt-3">
                <b-button type="submit" variant="primary" class="btn-block">Continue</b-button>
              </div>
            </b-form>
          </div>
        </div>
      </div>

    </div>
  </Layout>
</template>